import Urls from '../Urls';
import { axiosInstance } from './AxiosInstance';
import DateTime from '../Method/DateTime';
class TeacherProfileReq {
  teacherInfo = (params, id) => {
    return axiosInstance({
      url: Urls.teacherProfile(id),
      method: 'get',
      params,
    });
  };
  teacherInfoByUsername = (params, id) => {
    return axiosInstance({
      url: Urls.teacherProfileUsername(id),
      method: 'get',
      params,
    });
  };
  teacherWeekly = (params, id) => {
    return axiosInstance({
      url: Urls.teacherWeekly(id),
      method: 'get',
      params,
    });
  };
  teacherResume = (params, id) => {
    return axiosInstance({
      url: Urls.teacherResume(id),
      method: 'get',
      params,
    });
  };
  teacherReview = (id) => {
    return axiosInstance({
      url: Urls.teacherReview(id),
      method: 'get',
      params: {
        timeZone: DateTime.timeZone(),
        Page: 0,
        PageSize: 10,
      },
    });
  };
  teacherMoreReview = (params, id) => {
    return axiosInstance({
      url: Urls.teacherReview(id),
      method: 'get',
      params,
    });
  };
  usedTrials = (params, id) => {
    return axiosInstance({
      url: Urls.UsedTrials(),
      method: 'get',
      params,
    });
  };
}
export default new TeacherProfileReq();
